import { NETWORKS_LIST } from '@/core/config';
import { Network } from '@/shared/types/Network';

export function isNotEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== undefined && value !== null;
}

export function isNetwork(value: string): value is Network {
  return NETWORKS_LIST.indexOf(value as any) !== -1;
}
